import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {SpeedInsights} from "@vercel/speed-insights/react"
import {Analytics} from "@vercel/analytics/react"
import 'intersection-observer';
import {HelmetProvider} from '@dr.pogodin/react-helmet';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <SpeedInsights/>
        <Analytics/>
        <HelmetProvider>
            <App/>
        </HelmetProvider>
    </React.StrictMode>
);
